import { DocumentCard } from "@fluentui/react";
import React from "react";
import { CustomShimmer } from "../../../../helper/CustomShimmer";
import { CustomCardWithCharts } from "../../../../SharedComponents/CustomCardWithCharts";
import { groupBy } from "../../../../Utils/js-common";
import { HEALTH_VIEW_DATA } from "../../Common/HealthView.constants";
import { HEALTH_VIEW_STYLES } from "../../Common/HealthView.styles";
import { HealthViewMetricsCards } from "../../Common/HealthViewMetricsCards";

const HealthIntuneOverviewChart = (props: {
  loading: boolean;
  // options: MetricOptionProps<any>;
  onSelectedChartFilter: (filter: { filterKey: string; value: string }) => void;
  data: any[];
  healthDataByCustomerHealthScoreStatusKustoLink: string;
  healthDataBySupportHealthScoreStatusKustoLink: string;
  viewMode?: "tenant" | "tpid";
}) => {
  const isTPIDView = props.viewMode === "tpid";
  // Properties
  const [metricFilters, setMetricFilters] = React.useState<{ [key: string]: any }>({});

  // Events
  const handleResetFilters = () => {
    setMetricFilters({});
    props.onSelectedChartFilter({
      filterKey: "",
      value: ""
    });
  };
  /**
   * onClick action for each datapoint in the chart
   */
  const handleDataPointClick = (option: any) => {
    if (option.field && option.title && option.value) {
      props.onSelectedChartFilter({
        filterKey: option.field,
        value: option.value
      });
      setMetricFilters((prev) => ({ ...prev, [option.title]: option.value }));
    }
  };

  const getGroupedCountData = (key: string, data: any[]) => {
    const filteredData = data.filter((item) => item[key]);
    const groupedData = groupBy(filteredData, key);

    return Object.keys(groupedData)?.map((item) => ({
      name: item,
      value: groupedData[item].length,
      colour:
        item === "Healthy"
          ? HEALTH_VIEW_DATA.STATUS_COLOURS.Healthy
          : item === "Warning"
            ? HEALTH_VIEW_DATA.STATUS_COLOURS.Warning
            : item === "Critical"
              ? HEALTH_VIEW_DATA.STATUS_COLOURS.Critical
              : HEALTH_VIEW_DATA.STATUS_COLOURS.Other
    }));
  };

  const customerHealthScoreStatusData = getGroupedCountData("intune_CustomerHealthScoreStatus", props.data);
  const supportHealthScoreStatusData = getGroupedCountData("intune_SupportHealthScoreStatus", props.data)
    .filter((item) => item.name !== "N/A");

  return (
    <div className={HEALTH_VIEW_STYLES.COMMON_STYLES.COUNT_ANNOTATION.overviewContainer}>
      <DocumentCard className={HEALTH_VIEW_STYLES.COMMON_STYLES.COUNT_ANNOTATION.mainContainerStyle}>
        <div style={{ display: "flex", flexWrap: "nowrap", alignItems: "flex-start", gap: 6, width: "100%" }}>
          <div style={{ flex: "0 1 40%", minWidth: 300 }}>
            {props.loading ? (
              <CustomShimmer rowCount={1} columnCount={4} styles={HEALTH_VIEW_STYLES.OVERVIEW_SECTION.shimmerStyles} />
            ) : (
              <HealthViewMetricsCards
                totalE5SeatsField="e5_TotalSeats"
                totalCustomersField="tpid"
                totalTenantsField={isTPIDView ? undefined : "tenantId"}
                totalUATField="intune_UATFeatureRequests"
                totalDCRField="intune_DCRFeatureRequests"
                totalCRMField="intune_CRMFeatureRequests"
                totalActiveSRField="intune_ActiveSupportRequests"
                totalCritSitField="intune_CritSitCases"
                data={props.data}
              />
            )}
          </div>

          <div style={{ flex: "1 1 60%", minWidth: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap", gap: 8 }}>
            <CustomCardWithCharts
              enableUrlParams
              loading={props.loading}
              metricFilters={metricFilters}
              onDataPointClick={handleDataPointClick}
              onResetFilters={handleResetFilters}
              options={{
                chartOptions: [
                  {
                    id: 1,
                    field: "intune_CustomerHealthScoreStatus",
                    key: "customer-view-customer-engagements-support-chart-by-intune_CustomerHealthScoreStatus",
                    title: "Customer Health Score Status",
                    type: "donut",
                    kustoLink: props.healthDataByCustomerHealthScoreStatusKustoLink,
                    legendName: "Request Volume",
                    groupedData: customerHealthScoreStatusData
                  },
                  {
                    id: 2,
                    field: "intune_SupportHealthScoreStatus",
                    key: "customer-view-customer-engagements-support-chart-by-intune_SupportHealthScoreStatus",
                    title: "SHI Score Status",
                    type: "donut",
                    kustoLink: props.healthDataBySupportHealthScoreStatusKustoLink,
                    bannerText: "This chart excludes entries where SHI Score is empty",
                    groupedData: supportHealthScoreStatusData
                  }
                ]
              }}
            />
          </div>
        </div>
      </DocumentCard>
    </div>
  );
};

export default HealthIntuneOverviewChart;
